import { TABULAR_WIDGET_BREAKPOINT_2 } from '../../../../constants/generic';
import { SMPFlex, SMPText, StyledSMPTextVariants } from '../../../index';

type IMatchScoreProps = {
  homeTeamScore?: string | number;
  awayTeamScore?: string | number;
  homeTeamTiebreak?: string | number;
  awayTeamTiebreak?: string | number;
  matchUrlTarget?: string;
  matchLink?: string;
  variant?: StyledSMPTextVariants['variant'];
  fontWeight?: '400' | '700' | '900';
  homeTeamWeight?: StyledSMPTextVariants['weight'];
  awayTeamWeight?: StyledSMPTextVariants['weight'];
  handleEventClick?: (id: string | number) => void;
  eventId?: string;
  isMobile?: boolean;
  header?: string;
  width: number;
};

export const MatchScore = ({
  homeTeamScore,
  awayTeamScore,
  matchLink,
  matchUrlTarget,
  fontWeight,
  variant = 'contrast',
  homeTeamTiebreak,
  awayTeamTiebreak,
  homeTeamWeight,
  awayTeamWeight,
  handleEventClick,
  eventId,
  isMobile,
  header,
  width,
}: IMatchScoreProps): JSX.Element => {
  const weight = fontWeight ? fontWeight : '700';

  const teamScoreHeight = width >= TABULAR_WIDGET_BREAKPOINT_2 ? '$5_5' : 'calc(1em + 8px)';

  const homeTeamScorePassed = homeTeamScore !== undefined;
  const awayTeamScorePassed = awayTeamScore !== undefined;

  return (
    <SMPFlex
      justify='start'
      css={{
        '@bp0': { width: '20px' },
        '@bp2': { width: isMobile ? '20px' : '26px' },
      }}
    >
      <a
        href={matchLink}
        target={matchUrlTarget}
        onClick={() => handleEventClick && eventId && handleEventClick(eventId)}
        style={{ display: 'inline-flex', width: '100%', textDecoration: 'none' }}
      >
        <SMPFlex style={{ width: '100%' }} variant='column' align='center' justify='spaceAround'>
          {header !== undefined && (
            <SMPFlex css={{ width: '100%', height: '1em', fontSize: '$2_5' }}>
              <SMPText size='2_5' textAlign='center' weight='400' variant='scoreHeader' pale>
                {header}
              </SMPText>
            </SMPFlex>
          )}

          {homeTeamScorePassed && (
            <SMPFlex align='center' justify='center' style={{ width: '100%' }} css={{ height: teamScoreHeight, fontSize: '$3' }}>
              {homeTeamScore ? (
                <>
                  <SMPText variant={variant} size='3' weight={homeTeamWeight ?? weight} pale={Number(homeTeamWeight ?? weight) < 700}>
                    {homeTeamScore}
                  </SMPText>
                  {homeTeamTiebreak && (
                    <SMPText
                      variant={variant}
                      size='1'
                      weight={homeTeamWeight ?? weight}
                      css={{ mb: '1em' }}
                      pale={Number(homeTeamWeight ?? weight) < 700}
                    >
                      {homeTeamTiebreak}
                    </SMPText>
                  )}
                </>
              ) : (
                <SMPText variant={variant} size='3' pale>
                  -
                </SMPText>
              )}
            </SMPFlex>
          )}

          {awayTeamScorePassed && (
            <SMPFlex align='center' justify='center' style={{ width: '100%' }} css={{ height: teamScoreHeight, fontSize: '$3' }}>
              {awayTeamScore ? (
                <>
                  <SMPText variant={variant} size='3' weight={awayTeamWeight ?? weight} pale={Number(awayTeamWeight ?? weight) < 700}>
                    {awayTeamScore}
                  </SMPText>

                  {awayTeamTiebreak && (
                    <SMPText
                      variant={variant}
                      size='1'
                      weight={awayTeamWeight ?? weight}
                      css={{ mb: '1em' }}
                      pale={Number(awayTeamWeight ?? weight) < 700}
                    >
                      {awayTeamTiebreak}
                    </SMPText>
                  )}
                </>
              ) : (
                <SMPText variant={variant} size='3' pale>
                  -
                </SMPText>
              )}
            </SMPFlex>
          )}
        </SMPFlex>
      </a>
    </SMPFlex>
  );
};
